export class PreSelected<T> {
    constructor(
        public isOverridable: boolean,
        public value: T
    ) { }
}